import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "gfu-scroll-wrapper _flexcol _gap-2" }
const _hoisted_2 = { class: "gfu-scroll-section" }
const _hoisted_3 = { class: "_flex _-mx-2" }
const _hoisted_4 = { class: "_px-2" }
const _hoisted_5 = ["data-qa"]
const _hoisted_6 = {
  key: 1,
  class: "_flex _jcc _aic _w-full _pa-6 _tc--lighter"
}
const _hoisted_7 = {
  key: 0,
  class: "_flex _jc-fe"
}
const _hoisted_8 = ["href", "title", "data-qa"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_tab = _resolveComponent("base-tab")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_button = _resolveComponent("base-button")
  const _component_skeleton_card = _resolveComponent("skeleton-card")
  const _component_intersection_trigger = _resolveComponent("intersection-trigger")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "prefix"),
          ($options.shouldShowTagsNavigation)
            ? (_openBlock(), _createElementBlock("nav", {
                key: 0,
                class: _normalizeClass($options.tagsNavigationClasses),
                role: "tablist"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.mappedTags, (tag) => {
                  return (_openBlock(), _createBlock(_component_base_tab, {
                    key: tag.key,
                    tag: "a",
                    href: tag.url,
                    title: tag.label,
                    variant: "link",
                    "is-active": tag.isActive,
                    role: "tab",
                    "aria-selected": tag.isActive,
                    onClick: _withModifiers($event => ($options.onTagClick(tag.key)), ["prevent"]),
                    "data-qa": `explore-tag:${tag.label}`
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(tag.label), 1 /* TEXT */)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["href", "title", "is-active", "aria-selected", "onClick", "data-qa"]))
                }), 128 /* KEYED_FRAGMENT */))
              ], 2 /* CLASS */))
            : _createCommentVNode("v-if", true)
        ])
      ]),
      ($options.hasButtonNavigation)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["_flex _gap-1", $props.navigationWrapperClasses])
          }, [
            _createVNode(_component_base_button, {
              "aria-label": _ctx.Resources.Common.ScrollLeftButtonLabel,
              theme: "white",
              shape: "circle",
              shadow: "tight",
              disabled: $data.isScrollLeftDisabled,
              class: "_ba-0",
              onClick: $options.onScrollLeft,
              "data-qa": "left-arrow-button"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_base_icon, {
                  name: "chevron-left",
                  class: "_tc--accent",
                  size: "lg",
                  "aria-hidden": "true"
                })
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["aria-label", "disabled", "onClick"]),
            _createVNode(_component_base_button, {
              "aria-label": _ctx.Resources.Common.ScrollRightButtonLabel,
              theme: "white",
              shape: "circle",
              shadow: "tight",
              class: "_ba-0",
              disabled: $data.isScrollRightDisabled,
              onClick: $options.onScrollRight,
              "data-qa": "right-arrow-button"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_base_icon, {
                  name: "chevron-right",
                  class: "_tc--accent",
                  size: "lg",
                  "aria-hidden": "true"
                })
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["aria-label", "disabled", "onClick"])
          ], 2 /* CLASS */))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass($props.scrollContainerWrapperClasses)
    }, [
      _createElementVNode("div", {
        ref: "scrollContainer",
        class: _normalizeClass($options.effectiveScrollContainerClasses)
      }, [
        (!$props.isProcessing && $options.hasItems)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.items, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.props.key,
                  class: _normalizeClass($options.cardWrapperClasses),
                  "data-qa": item.props.dataQa
                }, [
                  _renderSlot(_ctx.$slots, "slide", { item: item }, () => [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(item.component), _mergeProps({ ref_for: true }, item.props, {
                      class: item.props.slideClasses
                    }), null, 16 /* FULL_PROPS */, ["class"])),
                    (item.customItemComponent)
                      ? (_openBlock(), _createBlock(_resolveDynamicComponent(item.customItemComponent), _mergeProps({
                          key: 0,
                          ref_for: true
                        }, item.customItemComponentProps, {
                          class: item.customItemComponentProps.slideClasses
                        }), null, 16 /* FULL_PROPS */, ["class"]))
                      : _createCommentVNode("v-if", true)
                  ])
                ], 10 /* CLASS, PROPS */, _hoisted_5))
              }), 128 /* KEYED_FRAGMENT */)),
              ($props.canLoadMoreRows)
                ? (_openBlock(), _createBlock(_component_intersection_trigger, {
                    key: 0,
                    root: _ctx.$refs.scrollContainer,
                    "root-margin": `0px 0px 0px 0px`,
                    threshold: 0,
                    onIntersected: $options.onIntersected
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.placeholders, (placeholder) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: placeholder,
                          class: _normalizeClass($options.cardWrapperClasses)
                        }, [
                          _renderSlot(_ctx.$slots, "placeholder", {}, () => [
                            _createVNode(_component_skeleton_card, { class: "_h-full" })
                          ])
                        ], 2 /* CLASS */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _: 3 /* FORWARDED */
                  }, 8 /* PROPS */, ["root", "onIntersected"]))
                : _createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */))
          : ($options.shouldShowEmptyState)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _renderSlot(_ctx.$slots, "empty-state", {}, () => [
                  _cache[1] || (_cache[1] = _createElementVNode("span", null, "No projects found", -1 /* CACHED */))
                ])
              ]))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList($options.placeholders, (placeholder) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: placeholder,
                  class: _normalizeClass($options.cardWrapperClasses)
                }, [
                  _renderSlot(_ctx.$slots, "placeholder", {}, () => [
                    _createVNode(_component_skeleton_card, { class: "_h-full" })
                  ])
                ], 2 /* CLASS */))
              }), 128 /* KEYED_FRAGMENT */))
      ], 2 /* CLASS */)
    ], 2 /* CLASS */),
    ($options.currentTag && $options.currentTag.url)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("a", {
            href: $options.currentTag.url,
            title: $options.currentTag.actionLabel,
            class: "gfu-link gfu-link--accent _whs-nw",
            onClick: _cache[0] || (_cache[0] = (...args) => ($options.onViewAllClick && $options.onViewAllClick(...args))),
            "data-qa": `view-projects-button:${$options.currentTag.actionLabel}`
          }, [
            _createTextVNode(_toDisplayString($options.currentTag.actionLabel) + " ", 1 /* TEXT */),
            _createVNode(_component_base_icon, {
              name: "chevron-right",
              "aria-hidden": "true"
            })
          ], 8 /* PROPS */, _hoisted_8)
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}